import { FC, SVGProps } from 'react'

export const LifeRing: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M8.93776 10.2321L4.03879 7.40363C4.03879 7.40363 3.10187 11.6344 3.78926 14.1998C4.47664 16.7651 7.40343 19.9607 7.40343 19.9607L10.2319 15.0617C10.2319 15.0617 9.35454 13.7193 9.10185 12.7763C8.84916 11.8332 8.93776 10.2321 8.93776 10.2321Z"
      fill="#FA8C16"
    />
    <path
      d="M13.5173 8.48733L16.3458 3.58835C16.3458 3.58835 12.115 2.65143 9.54961 3.33882C6.98425 4.0262 3.78873 6.95299 3.78873 6.95299L8.68771 9.78142C8.68771 9.78142 10.0301 8.9041 10.9731 8.65141C11.9162 8.39872 13.5173 8.48733 13.5173 8.48733Z"
      fill="#F5F5F5"
    />
    <path
      d="M10.241 15.5769L7.41254 20.4759C7.41254 20.4759 11.6433 21.4128 14.2087 20.7254C16.774 20.038 19.9696 17.1112 19.9696 17.1112L15.0706 14.2828C15.0706 14.2828 13.7282 15.1601 12.7852 15.4128C11.8421 15.6655 10.241 15.5769 10.241 15.5769Z"
      fill="#F5F5F5"
    />
    <path
      d="M14.2505 8.80822L17.0789 3.90924C17.0789 3.90924 20.0057 7.10476 20.6931 9.67012C21.3805 12.2355 20.4435 16.4663 20.4435 16.4663L15.5446 13.6378C15.5446 13.6378 15.6332 12.0367 15.3805 11.0936C15.1278 10.1506 14.2505 8.80822 14.2505 8.80822Z"
      fill="#FA8C16"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.50976 8.54081C3.72792 10.2314 3.51118 12.1951 4.03097 14.135C4.55143 16.0774 5.72333 17.6713 7.24863 18.7445L9.52858 14.8208C8.9882 14.3483 8.57738 13.7158 8.37763 12.9703C8.17798 12.2252 8.21739 11.4724 8.44884 10.7932L4.50976 8.54081ZM5.25984 7.2418L9.20569 9.49809C9.6752 8.97271 10.2979 8.57352 11.0293 8.37754C11.7614 8.18136 12.5011 8.216 13.1709 8.43685L15.4732 4.51632C13.7793 3.72906 11.81 3.50961 9.8646 4.03087C7.92508 4.55056 6.33305 5.71979 5.25984 7.2418ZM16.7708 5.26889L14.4735 9.18083C15.0127 9.65311 15.4226 10.2848 15.6221 11.0292C15.8218 11.7744 15.7823 12.5274 15.5508 13.2066L19.4889 15.4609C20.2716 13.7698 20.4888 11.8052 19.9687 9.8645C19.4505 7.93048 18.2865 6.34199 16.7708 5.26889ZM20.4431 16.8757C21.6911 14.7145 22.1146 12.0773 21.4176 9.47627C20.024 4.27498 14.6777 1.1883 9.47637 2.58198C4.27508 3.97567 1.1884 9.32195 2.58208 14.5232C3.97576 19.7245 9.32205 22.8112 14.5233 21.4175C17.1236 20.7208 19.1954 19.0362 20.4431 16.8757ZM18.7385 16.7597L14.7938 14.5017C14.3243 15.0269 13.7017 15.426 12.9704 15.622C12.2394 15.8179 11.5008 15.7836 10.8318 15.5637L8.54838 19.4933C10.2373 20.2723 12.1981 20.4877 14.1351 19.9686C16.0738 19.4492 17.6653 18.2807 18.7385 16.7597ZM11.4175 9.82643C10.2172 10.148 9.5049 11.3818 9.82652 12.5821C10.1481 13.7824 11.3819 14.4947 12.5822 14.1731C13.7825 13.8515 14.4948 12.6177 14.1732 11.4174C13.8516 10.2171 12.6178 9.50481 11.4175 9.82643Z"
      fill="black"
    />
  </svg>
)
